import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarHorizontalPosition,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  private matSnackbarRef: MatSnackBarRef<any> | undefined;
  private snackBarActionPressed = false;

  public isSnackbarEnabled = true;
  public isSnackbarOpen = false;

  constructor(
    private translateService: TranslateService,
    private _snackBar: MatSnackBar,
  ) {}

  openSnackBar(
    message: string,
    action: string,
    style: 'alert' | 'error',
    horizontalPos: MatSnackBarHorizontalPosition,
    executeFx: () => void,
    invertFx: () => void,
  ) {
    if (this.isSnackbarEnabled) {
      this.isSnackbarOpen = true;
      this.snackBarActionPressed = false;
      const snackbarConfig = new MatSnackBarConfig();
      switch (style) {
        case 'alert':
          snackbarConfig.panelClass = ['alert-snackbar'];
          snackbarConfig.verticalPosition = 'top';
          break;
        case 'error':
          snackbarConfig.panelClass = ['alert-snackbar'];
          snackbarConfig.verticalPosition = 'bottom';
          break;
        default:
          snackbarConfig.verticalPosition = 'bottom';
          break;
      }
      snackbarConfig.horizontalPosition = horizontalPos;
      snackbarConfig.duration = 5000;
      this.matSnackbarRef = this._snackBar.open(message, action, snackbarConfig);
      if (action !== this.translateService.instant('TOAST_CLOSE')) {
        this.matSnackbarRef.onAction().subscribe(() => {
          this.isSnackbarOpen = false;
          // console.log('***HAI PREMUTO ACTION***');
          // Se APRI => esegui, altrimenti inverti
          this.snackBarActionPressed = true;
          if (action === this.translateService.instant('TOAST_OPEN')) {
            executeFx();
          } else {
            invertFx();
          }
        });
        this.matSnackbarRef.afterDismissed().subscribe(() => {
          this.isSnackbarOpen = false;
          if (!this.snackBarActionPressed) {
            // console.log('***SNACKBAR CHIUSO SENZA AZIONE***');
            // Se APRI => inverti altrimenti esegui
            if (action === this.translateService.instant('TOAST_OPEN')) {
              invertFx();
            } else {
              executeFx();
            }
          }
        });
      }
    }
  }

  openSnackBarSimple(
    message: string,
    action: string,
    style: 'normal' | 'alert' | 'error',
    horizontalPos: MatSnackBarHorizontalPosition,
    executeFx: () => void,
    invertFx: () => void,
  ) {
    if (this.isSnackbarEnabled) {
      this.isSnackbarOpen = true;
      this.snackBarActionPressed = false;
      const snackbarConfig = new MatSnackBarConfig();
      switch (style) {
        case 'normal':
          //snackbarConfig.panelClass = ['normal-snackbar'];
          snackbarConfig.verticalPosition = 'top';
          break;
        case 'alert':
          snackbarConfig.panelClass = ['alert-snackbar'];
          snackbarConfig.verticalPosition = 'top';
          break;
        case 'error':
          snackbarConfig.panelClass = ['alert-snackbar'];
          snackbarConfig.verticalPosition = 'bottom';
          break;
        default:
          snackbarConfig.verticalPosition = 'bottom';
          break;
      }
      snackbarConfig.horizontalPosition = horizontalPos;
      snackbarConfig.duration = 5000;
      this.matSnackbarRef = this._snackBar.open(message, action, snackbarConfig);
      this.matSnackbarRef.onAction().subscribe(() => {
        this.isSnackbarOpen = false;
        // console.log('***HAI PREMUTO ACTION***');
        executeFx();
      });
      this.matSnackbarRef.afterDismissed().subscribe(() => {
        this.isSnackbarOpen = false;
        if (!this.snackBarActionPressed) {
          // console.log('***SNACKBAR CHIUSO SENZA AZIONE***');
          invertFx();
        }
      });
    }
  }
}
